export function formatRelayUrl(url: string) {
  return url.replace(/\/$/, '')
}
